import { Pipe, PipeTransform } from '@angular/core';

import { GroupUsers } from './../../../../../models/program/group-users';

@Pipe({ name: 'userSort' })

export class UserSortPipe implements PipeTransform {

  transform(value: GroupUsers[], args?: any): GroupUsers[] {
    value.sort((a: GroupUsers, b: GroupUsers) => {
      if (a.last_name < b.last_name) {
        return -1;
      } else if (a.last_name > b.last_name) {
        return 1;
      } else {
        return 0;
      }
    });
    return value;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/users/user-sort.pipe.ts